export const PinkDonutHalfSvg = () => (
  <svg
    width="288"
    height="144"
    viewBox="0 0 288 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M288 3.43437e-06L192 2.28958e-06C192 26.5097 170.51 48 144 48C117.49 48 95.9999 26.5097 95.9999 1.14479e-06L1.71718e-06 0C7.68809e-07 79.529 64.4709 144 144 144C223.529 144 288 79.529 288 3.43437e-06Z"
      fill="#E60278"
    />
  </svg>
);
